/* Lumeris : apparition au défilement (mobile et ordinateur).
   Contrôle à chaque défilement : rien ne reste caché, même après un saut d'ancre (#avis) ou un défilement très rapide. */
(function(){
  if(window.lmRevealInit)return;window.lmRevealInit=true;
  var SEL=['.lm-head','.lm-feat li','.lm-split__grid>*','.lm-grid>li','.lmst__it','.lmsp__media','.lmsp__txt','.lm-faq .lm-q','.lmp__img','.lmp__card','.lm-tbl','.lm-ban>*','.lm-rv__c','.lm-nl','.lms__list>*','.lms__grid>*','.lm-strip li','.lm-rvs__w'].join(',');
  var pending=[],ticking=false;
  function show(el){
    el.classList.add('lm-rv--in');
    setTimeout(function(){el.classList.remove('lm-rv','lm-rv--in');el.style.transitionDelay='';},1800);
  }
  function check(){
    ticking=false;
    var vh=window.innerHeight||800,keep=[];
    for(var i=0;i<pending.length;i++){
      var el=pending[i],r=el.getBoundingClientRect();
      if(r.top<vh*0.88){ if(r.bottom<0){el.style.transitionDelay='0ms';} show(el); } else keep.push(el);
    }
    pending=keep;
  }
  function onScroll(){ if(!ticking){ticking=true;setTimeout(check,16);} }
  function init(root){
    var vh=window.innerHeight||800;
    (root||document).querySelectorAll(SEL).forEach(function(el){
      if(el.dataset.lmRv||el.closest('.lmh,.product__info-wrapper,.cart-drawer,header,.lm-ft'))return;
      el.dataset.lmRv='1';
      if(el.getBoundingClientRect().top<vh*0.9)return; /* déjà visible ou au-dessus au chargement : pas d'effet */
      var sibs=Array.prototype.filter.call(el.parentNode.children,function(c){return c.matches(SEL);});
      var i=Math.min(sibs.indexOf(el),3);
      el.style.transitionDelay=(i>0?i*110:0)+'ms';
      el.classList.add('lm-rv');
      pending.push(el);
    });
  }
  function go(){init(document);onScroll();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
  window.addEventListener('hashchange',onScroll);
  window.addEventListener('load',onScroll);
  document.addEventListener('shopify:section:load',function(e){init(e.target);onScroll();});
})();
